import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import htmlParser from 'utils/htmlParser';
import s from './RollingBanner.css';

const COLOR_MAP = {
  orange: '#ea8f12',
  red: '#b12f26',
  darkBlue: '#33414e',
  steel: '#62717f',
  creamyWhite: '#faf9f7',
  lightBlue: '#eff2f5',
  white: '#fff',
  DEFAULT: '#33414e',
};

const TEXT_COLOR_MAP = {
  light: '#ffffff',
  dark: '#33414e',
};

const RollingBanner = ({ fields, children: [header, marquee] = [] } = {}) => {
  if (!header || !marquee) return null;

  const headerBackground = fields?.headlinePlateBackgroundColor?.rawText ?? 'lightBlue';
  const headerColor = fields?.headlineTextColor?.rawText ?? 'dark';
  const marqueeBackground = fields?.bannerBackgroundColor?.rawText ?? 'steel';
  const marqueeColor = fields?.bannerTextColor?.rawText ?? 'light';
  const headerText = header.fields?.paragraph?.rawText;
  const marqueeText = marquee.fields?.paragraph?.html ?? '';

  return (
    <div className={s.rollingBanner}>
      <span
        className={s.header}
        style={{ background: COLOR_MAP[headerBackground], color: TEXT_COLOR_MAP[headerColor] }}
      >
        {headerText}
      </span>
      <div
        className={s.marquee}
        style={{
          background: COLOR_MAP[marqueeBackground],
          color: TEXT_COLOR_MAP[marqueeColor],
          '--char-count': marqueeText.length,
        }}
      >
        <p>
          {htmlParser(marqueeText)} {htmlParser(marqueeText)}{' '}
        </p>
      </div>
    </div>
  );
};

export default withStyles(s)(RollingBanner);
